import FieldView from './FieldView'
import { useField } from './hooks/useField'

const Field = () => {
  const model = useField()

  if (!model.ready) {
    return null
  }

  return <FieldView {...model} />
}

export default Field
